import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  X,
  Mail,
  IdCard,
  ChevronRight,
  Monitor,
  MailCheck,
  PhoneCall,
  ThumbsDown,
  Check,
  Trophy,
  XCircle,
  ThumbsUp,
  Calendar,
  FileText,
  Plus,
  SquareStack,
  TimerIcon,
  User,
  MessageCircleCodeIcon,
  PhoneCallIcon,
  MessageCircle,
  PackageSearch,
  Slack,
  Send,
  ALargeSmall,
  CalendarSync,
  FlagIcon,
  Earth,
  CircleCheck,
} from "lucide-react";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import WonDeal from "../won-deal/won-form-deal";
import Swal from "sweetalert2";
import CommentsSection from "../../../../../component/comment";
import LostDeal from "../lost-deal/lost-form-deal";
import { Link } from "react-router";
import NewCardIcon from "../../../../../component/icons/action-card-icon";
import { Alert, Snackbar } from "@mui/material";
import AddActivity from "../../../../../component/modals/add-activity";
import { PopupTimeline } from "../../../../../component/ui/timeline";
import { FieldRow } from "../../../../../component/Popup-comp";
import Icon from "../../../../../component/icons/inner-pages-icons";

const tabs = [
  { key: "timeline", label: "Timeline", icon: <TimerIcon size={16} /> },
  { key: "summary", label: "Summary", icon: <User size={16} /> },
  { key: "stages", label: "Stages", icon: <SquareStack size={16} /> },
  {
    key: "comments",
    label: "Comments",
    icon: <MessageCircleCodeIcon size={16} />,
  },
  { key: "call", label: "Calls", icon: <PhoneCallIcon size={16} /> },
  { key: "emails", label: "Emails", icon: <Mail size={16} /> },
  { key: "sms", label: "Sms", icon: <MessageCircle size={16} /> },
];

function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}

function Badge({ children, tone = "default", icon: Icon }) {
  const tones = {
    default: "bg-slate-100 text-slate-700",
    green: "bg-emerald-100 text-emerald-700",
    blue: "bg-blue-100 text-blue-700",
    amber: "bg-amber-100 text-amber-800",
    red: "bg-rose-100 text-rose-700",
    grey: "bg-neutral-100 text-neutral-700",
    gray: "bg-gray-100 text-gray-800",
    yellow: "bg-yellow-100 text-yellow-700",
    orange: "bg-orange-100 text-orange-700",
    violet: "bg-violet-100 text-violet-700",
    neutral: "bg-gray-50 text-gray-700 border border-gray-200",
    pink: "bg-pink-200 text-pink-700",
    teal: "bg-teal-200 text-teal-700",
    indigo: "bg-indigo-200 text-indigo-700",
    sky: "bg-sky-200 text-sky-700",
    lime: "bg-lime-200 text-lime-700",
  };

  return (
    <span
      className={classNames(
        "inline-flex items-center gap-1 rounded-[6px]  px-[9px] py-[3px] text-[11px] font-medium",
        tones[tone],
      )}
    >
      {Icon ? <Icon size={14} /> : null}
      {children}
    </span>
  );
}

const Colors = {
  // lead

  // deal
  won: { background: "#e8f5e9", color: "#388e3c" }, // emerald green
  interested: { background: "#e8f5e9", color: "#388e3c" }, // emerald green
  "closed won": { background: "#e8f5e9", color: "#388e3c" }, // emerald green
  "need analysis": { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  proposal: { background: "#fff3e0", color: "#e65100" }, // deep orange
  "identify decision": { background: "#F3E8FF", color: "#9333EA" }, // violet
  lost: { background: "#fee2e2", color: "#b91c1c" }, // strong red
  "closed lost": { background: "#fee2e2", color: "#b91c1c" }, // strong red
  "value proposition": { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  review: { background: "#F5F5DC", color: "#6D4C41" }, // brown / sand
};

export default function DealQuickView({
  open = true,
  onClose = () => {},
  onSuccess = () => {},
  onError = () => {},
  data,
  DealStages = [],
}) {
  const [deal, setdeal] = useState({});
  const [activeTab, setActiveTab] = useState("timeline");
  const [status, setStatus] = useState(deal?.dealstatus);
  const containerRef = useRef(null);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(false);

  const [alertData, setAlertData] = useState({ isShow: false });
  const [changeModal, setChangeModal] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [usersList, setUsers] = useState([]);

  const GetData = async (id) => {
    let apiData = JSON.stringify({
      userid: id,
    });

    try {
      let call = await apiCall({
        method: "get",
        url: `deals/get-deal/${id}`,
        data: apiData,
      });
      let dealData = call?.data;

      console.log("ContactData", dealData);
      setIsLoading(true);

      let activity = dealData?.recent_activity?.map((item) => {
        const dateObj = new Date(item.time);
        const formattedDate = dateObj
          .toISOString()
          .slice(0, 16)
          .replace("T", " ");
        // This gives "YYYY-MM-DD HH:MM"

        return {
          ts: formattedDate,
          text: item.data,
        };
      });

      const sdata = {
        // ---------- DEAL SUMMARY ----------
        dealid: dealData?.dealid,
        name: dealData?.name,
        product: dealData?.deal_product_name,
        package: dealData?.deal_package_name,
        dealkey: dealData?.dealkey,
        dealstatus: dealData?.current_stage?.dealstatus,
        is_closed: dealData?.is_closed ? "Yes" : "No",
        dealtime: dealData?.dealtime * 1000,
        created_at: dealData?.created_at,
        product: dealData?.product,
        activities: dealData?.activities,

        // ---------- deal INFO ----------
        contactid: dealData?.contact?.userid,
        deal_name: dealData?.contact?.name,
        deal_email: dealData?.contact?.email,
        deal_phone: dealData?.contact?.phone,
        deal_source: dealData?.contact?.source,
        deal_page_source: dealData?.contact?.page_source,
        deal_company: dealData?.contact?.companyname,
        deal_signupdate: dealData?.contact?.signupdate,
        country: dealData?.contact?.country,
        stats: dealData?.stats,
        updated_at: dealData?.updated_at,

        // ---------- EXTRA ----------
        comments: dealData?.comments,
        stages: dealData?.stages,
        current_stage: dealData?.current_stage,
        metas: dealData?.metas,
        activity,
      };

      setStatus(dealData?.current_stage?.dealstatus);
      setdeal(sdata);
      setIsLoading(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key.toLowerCase() === "f" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        const el = document.getElementById("quickview-search");
        el?.focus();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSuccess = (message) => {
    if (onSuccess) onSuccess(message);
    setAlertData({ isShow: true, type: "success", message: message });
    // GetData(contact?.id);
    setChangeModal(false);
  };

  const onActivitySuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    GetData(deal?.dealid);
    setShowActivityModal(false);
  };

  useEffect(() => {
    if (activeTab === "timeline") {
      GetData(data?.dealid || deal?.dealid);
    }
  }, [activeTab, data]);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const T = {
    bg: "#EDE8E1",
    sidebar: "#1a1726",
    sidebarText: "rgba(255,255,255,0.45)",
    sidebarActive: "#FFFFFF",
    sidebarActiveBg: "rgba(99,102,241,0.15)",
    sidebarHover: "rgba(255,255,255,0.05)",
    sidebarAccent: "#818cf8",
    card: "#FFFFFF",
    cardBorder: "rgba(0,0,0,0.10)",
    cardHover: "#FAF8F6",
    text: "#1a1520",
    textSecondary: "#5c5466",
    textMuted: "#908892",
    border: "rgba(0,0,0,0.08)",
    accent: "#6366f1",
    accentLight: "#EEF0FF",
    accentText: "#4F46E5",
    inputBg: "#F3EFE9",
    inputBorder: "rgba(0,0,0,0.1)",
    modalBg: "#FFFFFF",
    rowHover: "#F5F1EC",
    selectedRow: "#EEEAFF",
    selectedBorder: "#6366f1",
    shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
    shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  };

  const css = {
    app: {
      display: "flex",
      height: "100vh",
      fontFamily: "'DM Sans', -apple-system, sans-serif",
      background: T.bg,
      color: T.text,
      overflow: "hidden",
    },
    sidebar: {
      width: 250,
      background: T.sidebar,
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      overflow: "hidden",
    },
    main: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    card: {
      background: T.card,
      border: `1px solid ${T.cardBorder}`,
      borderRadius: 12,
      padding: 16,
      boxShadow: T.shadow,
    },
    btn: {
      padding: "7px 14px",
      borderRadius: 8,
      border: `1px solid ${T.border}`,
      background: T.card,
      color: T.textSecondary,
      cursor: "pointer",
      fontSize: 13,
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontFamily: "inherit",
      transition: "all 0.15s",
      boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    },
    btnPrimary: {
      padding: "8px 18px",
      borderRadius: 8,
      border: "none",
      background: "linear-gradient(92deg,#0057FB 1.54%,#003495 114.12%)",
      color: "#fff",
      cursor: "pointer",
      fontSize: 13,
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontFamily: "inherit",
      boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
    },
    input: {
      background: T.inputBg,
      border: `1px solid ${T.inputBorder}`,
      borderRadius: 8,
      padding: "9px 12px",
      color: T.text,
      fontSize: 13,
      outline: "none",
      fontFamily: "inherit",
      width: "100%",
    },
    select: {
      background: T.inputBg,
      border: `1px solid ${T.inputBorder}`,
      borderRadius: 8,
      padding: "6px 12px",
      color: T.text,
      fontSize: 13,
      outline: "none",
      fontFamily: "inherit",
      cursor: "pointer",
    },
    badge: (color) => ({
      display: "inline-flex",
      alignItems: "center",
      padding: "3px 9px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color: color,
      letterSpacing: "0.3px",
    }),
    pill: (active) => ({
      padding: "5px 12px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: active ? 600 : 400,
      border: active
        ? "1px solid rgba(99,102,241,0.35)"
        : `1px solid ${T.border}`,
      background: active ? T.accentLight : T.card,
      color: active ? T.accentText : T.textMuted,
      cursor: "pointer",
      fontFamily: "inherit",
      boxShadow: active ? "none" : "0 1px 2px rgba(0,0,0,0.03)",
    }),
  };

  const activityColor = (type) =>
    ({
      call: "#3b82f6", // blue
      email: "#8b5cf6", // violet
      sms: "#06b6d4", // cyan
      consultation: "#f59e0b", // amber
      note: "#f59e0b", // amber
      meeting: "#10b981", // emerald
      stage: "#6366f1", // indigo
      "follow-up": "#6366f1", // indigo
      voicemail: "#ef4444", // red

      chat: "#0ea5e9", // sky blue
      presentation: "#14b8a6", // teal
      demo: "#a855f7", // purple
      default: "#a855f7", // purple
      messasge: "#f43f5e", // rose

      // remaining icons (added)
      phone: "#3b82f6", // blue
      comment: "#0ea5e9", // sky
      followup: "#6366f1", // indigo
      assign: "#22c55e", // green
      unassign: "#ef4444", // red
      file: "#eab308", // slate
      brief: "#eab308", // yellow
    })[type] || "#6b7280";

  ////////////// fake data for calls //////////////
  const refreshLead = {
    id: deal?.dealid,
    leadName: deal?.name,
    phone: deal?.deal_phone,
    activities: [
      // {
      //   id: 1,
      //   type: "call",
      //   summary: "Initial Discussion Call",
      //   date: "2024-07-01T10:30:00",
      //   agent: "Hendry",
      //   duration: "12m 45s",
      //   details:
      //     "Discussed product requirements and pricing structure. Client showed interest in premium plan.",
      // }
    ],
  };

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  const fmtTime = (iso) =>
    new Date(iso).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  const fmtDateTime = (iso) => `${fmtDate(iso)} ${fmtTime(iso)}`;

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 !pr-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.aside
              ref={containerRef}
              initial={{ x: 40, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 40, opacity: 0 }}
              transition={{ type: "spring", stiffness: 380, damping: 32 }}
              className="relative mt-0 mr-0 mb-auto ml-0 flex h-full p-[28px] pb-0 w-[810px] max-w-[98vw] flex-col overflow-hidden rounded-3xl rounded-r-none  border border-solid border-slate-200 bg-[#ffffff] shadow-xl"
              aria-modal
              role="dialog"
            >
              {isLoading ? (
                <>
                  {/* Header */}
                  <div className=" bg-white/90  backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                    <div className="flex flex-wrap items-center justify-between gap-3 w-full pb-4">
                      <div className="flex min-w-0 items-center gap-3">
                        <div className="flex items-center justify-center size-12  bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 rounded-full overflow-hidden">
                          <p className="capitalize font-semi-bold text-base text-black">
                            {deal?.name?.split(" ")?.map((n, i) => n.charAt(0))}
                          </p>
                        </div>
                        <div className="min-w-0">
                          <div className="flex items-center gap-2">
                            <h2 className="text-xl font-semibold text-slate-900 capitalize">
                              {deal?.name}
                            </h2>

                            {/* <Badge
                              tone={
                                status == "Need Analysis"
                                  ? "yellow"
                                  : status == "Value Proposition"
                                    ? "blue"
                                    : status == "Identify Decision"
                                      ? "violet"
                                      : status == "Proposal"
                                        ? "teal"
                                        : status == "Review"
                                          ? "indigo"
                                          : status == "Won"
                                            ? "green"
                                            : status == "Lost"
                                              ? "red"
                                              : "gray"
                              }
                              icon={BadgeCheck}
                            >
                              {status || "-"}
                            </Badge> */}

                            <span
                              className="inline-flex py-[4px] px-[12px] rounded-[6px] text-[10px] font-bold uppercase"
                              style={
                                Colors[status?.toLowerCase()] || {
                                  background: "#f5f5f5",
                                  color: "#616161",
                                }
                              }
                            >
                              {status}
                            </span>
                          </div>

                          <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
                            <span className="inline-flex items-center gap-1">
                              <MailCheck className="size-4" />{" "}
                              {deal?.deal_email}
                            </span>

                            <span className="inline-flex items-center gap-1">
                              <PhoneCall className="size-4" />{" "}
                              {deal?.deal_phone}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                          onClick={onClose}
                          aria-label="Close"
                        >
                          <X className="size-4" /> Exit
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Body */}
                  <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-hidden  pt-0 w-full">
                    {/* Left: main content */}
                    <div className="col-span-12 flex min-h-0 flex-col gap-4">
                      {/* Top stats */}

                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          // marginTop: 14,
                          flexWrap: "wrap",
                        }}
                      >
                        {deal?.stats?.map(
                          (ele, idx) =>
                            ele?.value !== "-" &&
                            ele?.value !== null && (
                              <div
                                style={{
                                  padding: "8px 14px",
                                  background: "#F3EFE9",
                                  borderRadius: 10,
                                  border: `1px solid rgba(0,0,0,0.08)`,
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 10,
                                    color: "#908892",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {ele?.key?.includes("_")
                                    ? ele?.key
                                        ?.split("_")
                                        .map((word) => ` ${word}`)
                                    : ele?.key}
                                </div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    marginTop: 3,
                                    color: "#1a1520",
                                  }}
                                >
                                  {ele?.value}
                                </div>
                              </div>
                            ),
                        )}
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          className="inline-flex items-center gap-1.5 tracking-normal rounded-lg bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                          hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)] px-[18px] py-2 text-[13px] font-semibold text-white"
                          onClick={() => setShowActivityModal(true)}
                          aria-label="Close"
                        >
                          <Plus className="size-[14px]" /> Add Follow Up
                        </button>

                        <Link
                          to={`/lead-account/detail/${deal?.contactid}/deal/${deal?.dealid}`}
                          target="_blank"
                          className="inline-flex items-center gap-1.5 rounded-lg border border-solid border-[rgba(0,0,0,0.1)] bg-[rgb(243,239,233)]  px-[18px] py-2 text-[13px] font-semibold text-[rgb(26,21,32)] hover:bg-slate-50"
                        >
                          <NewCardIcon className="!size-[14px]" /> View Full
                          Details
                        </Link>
                      </div>

                      {/* Tabs */}
                      <div className="border-y border-solid pt-1 border-slate-200 flex items-center justify-between gap-2">
                        <div className="flex flex-wrap items-center gap-1">
                          {tabs?.map((t) => (
                            <button
                              key={t.key}
                              onClick={() => setActiveTab(t.key)}
                              className={classNames(
                                "flex items-center gap-[6px] px-[16px] py-[11px] text-[13px] font-normal border-b-2 transition-all duration-200",
                                activeTab === t.key
                                  ? "border-blue-600 text-blue-600 font-semibold"
                                  : "border-transparent text-slate-500 hover:text-slate-800",
                              )}
                            >
                              {t.icon}
                              {t.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="h-full overflow-auto rounded-2xl py-2">
                        {activeTab === "timeline" && (
                          <PopupTimeline timeline={deal?.activities} />
                        )}

                        {activeTab === "summary" && (
                          <>
                            <div>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Deal Information
                              </div>

                              <div className="grid gap-6 md:grid-cols-2 w-full px-[10px]">
                                <FieldRow
                                  label="Name:"
                                  value={deal?.deal_name || "-"}
                                  LabelIcon={ALargeSmall}
                                />
                                <FieldRow
                                  label="Email"
                                  value={deal?.deal_email || "-"}
                                  LabelIcon={Send}
                                  isCapitalize={false}
                                  isCopyable={true}
                                />

                                <FieldRow
                                  label="Phone"
                                  value={deal?.deal_phone || "-"}
                                  LabelIcon={PhoneCall}
                                />
                                <FieldRow
                                  label="Product"
                                  value={deal?.product?.products || "-"}
                                  LabelIcon={PackageSearch}
                                />

                                <FieldRow
                                  label="Brand Name"
                                  value={deal?.brand?.brand_name}
                                  LabelIcon={Slack}
                                  isLink={true}
                                  LinkValue={deal?.brand?.brandurl}
                                />
                                <FieldRow
                                  label="Date"
                                  value={deal?.created_at || "-"}
                                  LabelIcon={CalendarSync}
                                />

                                <FieldRow
                                  label="Country"
                                  value={deal?.country ?? "-"}
                                  LabelIcon={FlagIcon}
                                />

                                <FieldRow
                                  label="Company"
                                  value={deal?.deal_company ?? "-"}
                                  LabelIcon={Earth}
                                />

                                <FieldRow
                                  label="Package"
                                  value={deal?.package || "-"}
                                  LabelIcon={CircleCheck}
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {activeTab === "stages" && (
                          <div className="space-y-3">
                            <DealCard
                              deal={deal}
                              onSubmit={handleSuccess}
                              DealStages={DealStages}
                              onError={onError}
                              onStatusChange={(dealId, newStatus) => {
                                setdeal((prev) => {
                                  return {
                                    ...prev,
                                    current_stage: {
                                      ...prev?.current_stage,
                                      dealstatus: newStatus,
                                    },
                                  };
                                });
                              }}
                            />
                          </div>
                        )}

                        {activeTab === "comments" && (
                          <CommentsSection
                            type="deal"
                            id={deal?.dealid}
                            apiBaseUrl="deal"
                            setAlertData={setAlertData}
                          />
                        )}

                        {activeTab === "call" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            <div style={css.card}>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Make a Call
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: 8,
                                  marginBottom: 16,
                                }}
                              >
                                <input
                                  style={{ ...css.input, flex: 1 }}
                                  value={refreshLead.phone}
                                  readOnly
                                />
                                <button style={css.btnPrimary}>
                                  {/* {I("phone", 14)} Call Now */}
                                  <Icon name="phone" size={14} /> Call Now
                                </button>
                              </div>
                            </div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 8,
                              }}
                            >
                              Call History
                            </div>
                            {refreshLead.activities
                              .filter(
                                (a) =>
                                  a.type === "call" || a.type === "voicemail",
                              )
                              .map((call) => (
                                <div
                                  key={call.id}
                                  style={{
                                    ...css.card,
                                    display: "flex",
                                    gap: 12,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 34,
                                      height: 34,
                                      borderRadius: "50%",
                                      background:
                                        activityColor(call.type) + "12",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: activityColor(call.type),
                                      flexShrink: 0,
                                    }}
                                  >
                                    {/* {I(activityIcon(call.type), 15)} */}
                                    <Icon name="call" size={15} />
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: 2,
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: 13,
                                          fontWeight: 600,
                                          color: T.text,
                                        }}
                                      >
                                        {call.summary}
                                      </span>
                                      <span
                                        style={{
                                          fontSize: 11,
                                          color: T.textMuted,
                                        }}
                                      >
                                        {fmtDateTime(call.date)}
                                      </span>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        color: T.textMuted,
                                        marginBottom: 4,
                                      }}
                                    >
                                      {call.agent} · {call.duration}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        color: T.textSecondary,
                                      }}
                                    >
                                      {call.details}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            {refreshLead.activities.filter(
                              (a) =>
                                a.type === "call" || a.type === "voicemail",
                            ).length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: T.textMuted,
                                  padding: 40,
                                }}
                              >
                                No call history
                              </div>
                            )}
                          </div>
                        )}

                        {activeTab === "emails" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            <div style={css.card}>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Compose Email
                              </div>
                              <input
                                placeholder="Subject..."
                                style={{ ...css.input, marginBottom: 8 }}
                              />
                              <textarea
                                placeholder="Type your email message..."
                                style={{
                                  ...css.input,
                                  minHeight: 120,
                                  resize: "vertical",
                                  marginBottom: 8,
                                }}
                              />
                              <button style={css.btnPrimary}>
                                {/* {I("send", 14)} Send Email */}
                                <Icon name="send" size={14} /> Send Email
                              </button>
                            </div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 8,
                              }}
                            >
                              Email History
                            </div>
                            {refreshLead.activities
                              .filter((a) => a.type === "email")
                              .map((email) => (
                                <div key={email.id} style={{ ...css.card }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: T.text,
                                      }}
                                    >
                                      {email.summary}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 11,
                                        color: T.textMuted,
                                      }}
                                    >
                                      {fmtDateTime(email.date)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: T.textMuted,
                                      marginBottom: 4,
                                    }}
                                  >
                                    From: {email.agent}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 13,
                                      color: T.textSecondary,
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {email.details}
                                  </div>
                                </div>
                              ))}
                            {refreshLead.activities.filter(
                              (a) => a.type === "email",
                            ).length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: T.textMuted,
                                  padding: 40,
                                }}
                              >
                                No email history
                              </div>
                            )}
                          </div>
                        )}

                        {activeTab === "sms" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            <div style={css.card}>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Send SMS
                              </div>
                              <textarea
                                placeholder="Type your message..."
                                style={{
                                  ...css.input,
                                  minHeight: 80,
                                  resize: "vertical",
                                  marginBottom: 8,
                                }}
                              />
                              <button style={css.btnPrimary}>
                                {/* {I("send", 14)} Send SMS */}
                                <Icon name="send" size={14} /> Send SMS
                              </button>
                            </div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 8,
                              }}
                            >
                              SMS History
                            </div>
                            {refreshLead.activities
                              .filter((a) => a.type === "sms")
                              .map((sms) => (
                                <div key={sms.id} style={{ ...css.card }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: T.text,
                                      }}
                                    >
                                      {sms.summary}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 11,
                                        color: T.textMuted,
                                      }}
                                    >
                                      {fmtDateTime(sms.date)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: T.textMuted,
                                      marginBottom: 4,
                                    }}
                                  >
                                    {sms.agent}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 13,
                                      color: T.textSecondary,
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {sms.details}
                                  </div>
                                </div>
                              ))}
                            {refreshLead.activities.filter(
                              (a) => a.type === "sms",
                            ).length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: T.textMuted,
                                  padding: 40,
                                }}
                              >
                                No SMS history
                              </div>
                            )}
                          </div>
                          // <TabPlaceholder
                          //   icon={MessageSquare}
                          //   title="SMS"
                          //   message="SMS communication history is under development."
                          // />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex items-center justify-between gap-2 border-t border-solid border-slate-200 bg-white p-3 w-full">
                    <div className="flex items-center gap-2 text-xs text-slate-500">
                      <IdCard className="size-4" /> ID {deal?.dealid}
                    </div>
                  </div>
                </>
              ) : (
                <InnerLoader wrapperClass={"w-full"} />
              )}
            </motion.aside>
          </motion.div>
        )}
      </AnimatePresence>

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>

      {showActivityModal && (
        // <EmployeeDirectoryAddUpdate
        //   onClose={() => {
        //     setShowActivityModal(false);
        //   }}
        //   data={null}
        //   tabIndex={2}
        //   onError={onError}
        //   onSubmit={onActivitySuccess}
        //   id={deal?.dealid}
        //   entitytype="deal"
        //   entityname={deal.name}
        // />
        <AddActivity
          onSubmit={onActivitySuccess}
          onClose={() => {
            setShowActivityModal(false);
          }}
          onError={onError}
          UsersList={usersList}
          CustomerData={null}
          id={deal?.dealid}
          entitytype="deal"
          entityname={deal.name}
        />
      )}
    </>
  );
}

function QuickAction({ icon: Icon, label, href, onClick }) {
  const className =
    "inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50";
  if (href)
    return (
      <a className={className} href={href}>
        <Icon className="size-4" /> {label}
      </a>
    );
  return (
    <button className={className} onClick={onClick}>
      <Icon className="size-4" /> {label}
    </button>
  );
}

function Activity({ items, compact = false }) {
  return (
    <ul className="space-y-3">
      {items?.map((a, i) => (
        <li key={i} className="flex items-start gap-3">
          <div className="mt-1 h-5 w-5 rounded-full bg-slate-100 ring-1 ring-slate-200" />
          <div className="min-w-0 flex-1">
            <div className="text-[13px] text-slate-800 pb-[5px]">{a.text}</div>
            <div className="text-[11px] text-slate-400">{formatTs(a.ts)}</div>
          </div>
        </li>
      ))}
      {!compact && (
        <button className="mt-1 inline-flex items-center gap-1 text-xs text-slate-600 hover:underline">
          View full activity <ChevronRight className="size-4" />
        </button>
      )}
    </ul>
  );
}

function Assets({ assets }) {
  return (
    <div className="space-y-3">
      {assets?.map((a, i) => (
        <div
          key={i}
          className="flex items-center justify-between rounded-xl border border-solid border-slate-200 bg-white p-3"
        >
          <div className="flex min-w-0 items-center gap-3">
            <Monitor className="size-5" />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium">{a.name}</div>
              <div className="truncate text-xs text-slate-500">{a.id}</div>
            </div>
          </div>
          <Badge tone={a.status === "Assigned" ? "blue" : "grey"}>
            {a.status}
          </Badge>
        </div>
      ))}
      <button className="inline-flex items-center gap-1 text-xs text-slate-600 hover:underline">
        Manage assets <ChevronRight className="size-4" />
      </button>
    </div>
  );
}

function Notes() {
  const [notes, setNotes] = useState([
    {
      id: 1,
      text: "Great initiative on latest branding sprint. Keep momentum for Q4.",
      ts: Date.now() - 86400000,
    },
  ]);
  const [text, setText] = useState("");
  return (
    <div className="space-y-3">
      <div className="rounded-2xl border border-solid border-slate-200 bg-white p-3">
        <textarea
          id="addNotesField"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add a manager note (visible to HR/Managers)…"
          className="min-h-[90px] w-full resize-y rounded-xl border border-solid border-slate-200 bg-slate-50 p-3 text-sm outline-none focus:ring-2 focus:ring-slate-900/10"
        />
        <div className="mt-2 flex justify-end">
          <button
            onClick={() => {
              if (!text.trim()) return;
              setNotes((n) => [{ id: Date.now(), text, ts: Date.now() }, ...n]);
              setText("");
            }}
            className="rounded-xl bg-slate-900 px-3 py-1.5 text-xs text-white hover:bg-slate-800"
          >
            Save Note
          </button>
        </div>
      </div>
      <ul className="space-y-2">
        {notes?.map((n) => (
          <li
            key={n.id}
            className="rounded-xl border border-solid border-slate-200 bg-white p-3"
          >
            <div className="text-sm text-slate-800">{n.text}</div>
            <div className="text-[11px] text-slate-400">
              {new Date(n.ts).toLocaleString()}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

function formatTs(ts) {
  try {
    const d =
      typeof ts === "string" ? new Date(ts.replace(" ", "T")) : new Date(ts);
    return d.toLocaleString();
  } catch {
    return String(ts);
  }
}

function DealCard({
  deal,
  onStatusChange,
  DealStages = [],
  onSubmit = () => {},
  onError = () => {},
}) {
  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);

  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);

  const [localStage, setLocalStage] = useState(
    deal?.current_stage?.dealstatus ?? "-",
  );

  const apiCall = useApiCall();

  const handleSuccess = (message) => {
    setWonFormDeal(false);
    setShowLostModal(false);
    onSubmit(message);
  };

  const handleError = (message) => {
    if (onError) onError(message);
  };

  console.log("deal", deal);

  console.log("DealStages at render:", DealStages);
  console.log("deal.current_stage.dealstatus:", deal.current_stage.dealstatus);

  const isWon = deal?.current_stage?.dealstatus === "Won";
  const isLost = deal?.current_stage?.dealstatus === "Lost";
  const currentStageIndex = DealStages.findIndex(
    (s) => s.name === deal?.current_stage?.dealstatus,
  );

  const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";
  const isWonOrLost = isWon || isLost;

  const formatStageKey = (stage) => stage.toLowerCase().replace(/\s+/g, "_");

  // --- HANDLE STAGE CHANGE ---
  const handleStageChange = async (newStage) => {
    const lowerStage = formatStageKey(newStage);
    const currentStage = deal?.current_stage?.dealstatus ?? "-";

    if (lowerStage === "won") {
      setWonFormDeal(deal);
      setShowWonModal(true);
      return;
    }

    if (lowerStage === "lost") {
      setLostFormDeal({ dealkey: deal.dealkey, name: deal.name });
      setShowLostModal(true);
      return;
    }

    const resultSwal = await Swal.fire({
      title: `Move deal "${deal.name}"?`,
      text: `Move from "${currentStage}" to "${newStage}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (resultSwal.isConfirmed) {
      try {
        await apiCall({
          method: "post",
          url: "deals/update-deal-status",
          data: { dealkey: deal.dealkey, dealstatus: lowerStage },
        });

        onStatusChange(deal.dealid, newStage);
        Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
      } catch (err) {
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "error",
        );
      }
    }
  };

  const metas = Object.fromEntries(
    deal?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? [],
  );

  return (
    <>
      <div
        className="relative rounded-xl   px-5 py-4   border border-slate-200 bg-white  shadow-sm hover:shadow-md transition-all duration-300 
             space-y-3 text-sm w-full cursor-pointer hover:-translate-y-[1px]"
      >
        {/* Stage Pipeline */}
        <div className="mt-2">
          <p className="text-xs text-slate-500 mb-1 font-medium">
            Stage Pipeline
          </p>
          <div className="flex w-full h-7 overflow-hidden rounded-md">
            {DealStages.map((s, i) => {
              const isActive = !isWonOrLost && i <= currentStageIndex;
              const isCurrent = i === currentStageIndex;
              const isFirst = i === 0;
              const isLast = i === DealStages.length - 1;

              let clipPath = "";
              if (isFirst)
                clipPath =
                  "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)";
              else if (isLast)
                clipPath = "polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0)";
              else
                clipPath =
                  "polygon(0 0, 10px 50%, 0 100%, calc(100% - 10px) 100%, 100% 50%, calc(100% - 10px) 0)";

              return (
                <div
                  key={s.id}
                  onClick={() =>
                    !isWonOrLost && !isCurrent && handleStageChange(s.name)
                  }
                  title={s.name}
                  style={{
                    clipPath,
                    WebkitClipPath: clipPath,
                    backgroundColor:
                      i <= currentStageIndex && !isWonOrLost
                        ? activeColor
                        : "#e5e7eb",
                    transition: "background-color 0.3s ease",
                    cursor:
                      isWonOrLost || isCurrent ? "not-allowed" : "pointer",
                  }}
                  className="flex-1 relative flex items-center justify-center text-[10px] font-medium text-white select-none"
                >
                  {i <= currentStageIndex && !isWonOrLost ? (
                    <Check className="size-3" />
                  ) : (
                    s.name[0]
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Actions Row */}
        <div className="flex justify-between items-center mt-4">
          {/* Won/Lost Badge */}
          <div>
            {(isWon || isLost) && (
              <div
                className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${
                  isWon
                    ? "bg-green-100 text-green-700"
                    : "bg-rose-100 text-rose-700"
                }`}
              >
                {isWon ? (
                  <Trophy className="size-3" />
                ) : (
                  <XCircle className="size-3" />
                )}
                {isWon ? "Won" : "Lost"}
              </div>
            )}
            {!isWon && !isLost && <div className="h-[22px]" />}
          </div>

          {/* Action Icons */}
          <div className="flex items-center gap-3">
            {/* <button
              title="Add Comment"
              className="p-2 rounded-full bg-slate-100 hover:bg-blue-100 hover:text-blue-600 text-slate-500 transition"
            >
              <MessageSquare className="size-4" />
            </button> */}

            <button
              onClick={() => !isWonOrLost && handleStageChange("Won")}
              title="Mark as Won"
              className={`p-2 rounded-full transition ${isWonOrLost ? "cursor-not-allowed" : "cursor-pointer"} ${
                isWon
                  ? "bg-green-500 text-white"
                  : "bg-slate-100 text-slate-500 hover:bg-green-100 hover:text-green-600"
              }`}
            >
              <ThumbsUp className="size-4" />
            </button>

            <button
              onClick={() => !isWonOrLost && handleStageChange("Lost")}
              title="Mark as Lost"
              className={`p-2 rounded-full transition ${isWonOrLost ? "cursor-not-allowed" : "cursor-pointer"} ${
                isLost
                  ? "bg-rose-500 text-white"
                  : "bg-slate-100 text-slate-500 hover:bg-rose-100 hover:text-rose-600"
              }`}
            >
              <ThumbsDown className="size-4" />
            </button>
          </div>
        </div>
      </div>

      {/* Won Deal Modal */}
      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onDealUpdated={() => onStatusChange(deal.dealid)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}
    </>
  );
}

function TabPlaceholder({ icon: Icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-slate-300 rounded-2xl bg-white">
      <div className="flex items-center justify-center size-14 rounded-full bg-slate-100 mb-4">
        <Icon className="size-6 text-slate-500" />
      </div>
      <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      <div className="mt-4 px-4 py-2 text-xs text-slate-400 border border-solid border-slate-200 rounded-full bg-slate-50">
        🚧 Under Development
      </div>
    </div>
  );
}
